import React from "react";

export const SERP_FEATURE_TYPE = {
  FEATURED_SNIPPET: 'FEATURED_SNIPPET',
  AI_OVERVIEW: 'AI_OVERVIEW',
  SHOP_RESULTS: 'SHOP_RESULTS',
  MAP_PACK: 'MAP_PACK',
  KNO_GRAPH: 'KNO_GRAPH',
  PEOPLE_ALSO_ASK: 'PEOPLE_ALSO_ASK',
  NONE: 'NONE',
} as const;

export type CategorizationType = keyof typeof SERP_FEATURE_TYPE;

export const SERP_FEATURE_MAP: Record<
  CategorizationType,
  {
    label: () => JSX.Element;
    filterItemLabel: string;
    tooltip: (params?: { missingWords?: string }) => JSX.Element;
  }
> = {
  [SERP_FEATURE_TYPE.FEATURED_SNIPPET]: {
    label: ({ color = 'white' } = {}) => (
      <svg
        viewBox="0 0 32 32"
        width="100%"
        height="100%"
      >
        <path
          fill={color}
          d="M24.9 6c.8 0 1.1.3 1.1 1.1v17.8c0 .8-.3 1.1-1.1 1.1H7.1c-.8 0-1.1-.3-1.1-1.1V7.1C6 6.3 6.3 6 7.1 6h17.8zm0-2H7.1C5.4 4 4 5.4 4 7.1v17.8C4 26.6 5.4 28 7.1 28h17.8c1.7 0 3.1-1.4 3.1-3.1V7.1C28 5.4 26.6 4 24.9 4z"
        />
        <path
          fill={color}
          d="M5 7h21v2H5V7zM4 23h23v2H4v-2zm8.7-11.9c-1.2 0-2.2 1-2.2 2.3 0 1.2 1 2.3 2.2 2.3 2.2 0 .7 4.4-2.2 4.4v.9c5.3 0 7.3-9.9 2.2-9.9zm6.4 0c-1.2 0-2.2 1-2.2 2.3 0 1.2 1 2.3 2.2 2.3 2.2 0 .7 4.4-2.2 4.4v.9c5.2 0 7.3-9.9 2.2-9.9z"
        />
      </svg>
    ),
    filterItemLabel: 'Featured Snippet',
    tooltip: () => <>Featured Snippet: Users are looking for a certain website or a page.</>,
  },
  [SERP_FEATURE_TYPE.PEOPLE_ALSO_ASK]: {
    label: ({ color = 'white' } = {}) => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width="100%"
        height="100%"
      >
        <path
          d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
          fill={color}
        />
      </svg>
    ),
    filterItemLabel: 'People Also Ask',
    tooltip: () => <>People Also Ask: Users are looking for a certain website or a page.</>,
  },
  [SERP_FEATURE_TYPE.AI_OVERVIEW]: {
    label: ({ color = 'white' } = {}) => (
      <svg
        fillRule="evenodd"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
      >
        <path
          d="M12 24A14.304 14.304 0 000 12 14.304 14.304 0 0012 0a14.305 14.305 0 0012 12 14.305 14.305 0 00-12 12"
          fill={color}
        />
      </svg>
    ),
    filterItemLabel: 'AI Overview',
    tooltip: () => <>AI Overview: Users are looking for information on a specific topic or an answer to their question.</>,
  },
  [SERP_FEATURE_TYPE.SHOP_RESULTS]: {
    label: ({ color = 'white' } = {}) => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        width="100%"
        height="100%"
      >
        <path
          fill={color}
          d="M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        />
      </svg>
    ),
    filterItemLabel: 'Shopping Ads',
    tooltip: () => <>Shopping Ads: Users have a very clear intent to make a purchase.</>,
  },
  [SERP_FEATURE_TYPE.MAP_PACK]: {
    label: ({ color = 'white' } = {}) => (
      <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
      >
        <path
          d="M22 7.2V7L21.7 7.1C21.7 7.4 21.8 7.6 21.8 7.9C21.8 9.2 21.5 10.5 21 11.8V23.7L18 25.2L17 25.8V19.4C16.3 20.5 15.7 21.1 15.7 21.1C15.7 21.1 15.4 20.7 15 20.1V25.5L14 25.2L10.4 23.8C10.2 23.7 10.1 23.7 10 23.7V10.2C9.8 9.5 9.7 8.7 9.7 7.9C9.7 7.6 9.7 7.3 9.8 7.1L4 9.5V27.8L10 25.5L16 27.8L22 25.5L28 27.8V9.5L22 7.2ZM9 23.8L6 25.3V10.6L9 9.4V23.8ZM26 25.3L22.4 23.9C22.2 23.8 22.1 23.8 22 23.8V9L26 10.6V25.3Z"
          fill={color}
        />
        <path
          d="M15.7001 4.2998C13.2001 4.2998 11.1001 6.2998 11.1001 8.8998C11.1001 13.1998 15.7001 18.8998 15.7001 18.8998C15.7001 18.8998 20.3001 13.1998 20.3001 8.8998C20.3001 6.2998 18.2001 4.2998 15.7001 4.2998ZM15.7001 11.2998C14.3001 11.2998 13.2001 10.1998 13.2001 8.7998C13.2001 7.3998 14.3001 6.2998 15.7001 6.2998C17.1001 6.2998 18.2001 7.3998 18.2001 8.7998C18.2001 10.1998 17.1001 11.2998 15.7001 11.2998Z"
          fill={color}
        />
      </svg>
    ),
    filterItemLabel: 'Map Pack',
    tooltip: () => <>Map Pack: Users are comparing products or services before making a purchase decision.</>,
  },
  [SERP_FEATURE_TYPE.KNO_GRAPH]: {
    label: ({ color = 'white' } = {}) => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width="100%"
        height="100%"
      >
        <path
          d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
          fill={color}
        />
      </svg>
    ),
    filterItemLabel: 'Knowledge Graph',
    tooltip: () => <>Knowledge Graph: Users are comparing products or services before making a purchase decision.</>,
  },
  [SERP_FEATURE_TYPE.NONE]: {
    label: () => <span style={{ fontWeight: 'normal', fontSize: '10px' }}>-</span>,
    filterItemLabel: 'None',
    tooltip: () => <>We haven’t found any essential SERP features</>,
  },
};
